var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, where, limit, startAfter } from "firebase/firestore";
import { OrderStatus } from "@tiffin/core";
import { auth, cloudFunction, db } from "../firebase";
var ORDER_LIMIT = 10;
export function subscribeToOrdersByPaymentIntent(paymentIntentId, callback) {
    var ordersRef = collection(db, "orders");
    var ordersQuery = query(ordersRef, where('paymentIntent', '==', paymentIntentId), where("customerId", "==", auth.currentUser.uid));
    var unsubscribe = onSnapshot(ordersQuery, function (querySnapshot) {
        var records = [];
        querySnapshot.forEach(function (doc) {
            records.push(__assign({ id: doc.id }, doc.data()));
        });
        callback(records);
    }, function (err) {
        console.error(err);
    });
    return unsubscribe;
}
export function subscribeToOrder(id, callback) {
    var unsubscribe = onSnapshot(doc(db, "orders", id), function (doc) {
        callback(__assign({ id: id, key: id }, doc.data()));
    });
    return unsubscribe;
}
export function fetchCustomerPendingOrders(partnerId) {
    return new Promise(function (resolve, reject) {
        var ordersRef = collection(db, "orders");
        var ordersQuery;
        if (partnerId) {
            ordersQuery = query(ordersRef, where("customerId", "==", auth.currentUser.uid), where("tiffinId", "==", partnerId), where("status", ">=", OrderStatus.Unconfirmed), where("status", "<", OrderStatus.Completed));
        }
        else {
            ordersQuery = query(ordersRef, where("customerId", "==", auth.currentUser.uid), where("status", ">=", OrderStatus.Unconfirmed), where("status", "<", OrderStatus.Completed));
        }
        getDocs(ordersQuery).then(function (querySnapshot) {
            var records = [];
            querySnapshot.forEach(function (doc) {
                records.push(__assign({ id: doc.id, key: doc.id }, doc.data()));
            });
            resolve(records);
        }, function (err) { return console.error(err); });
    });
}
export function fetchCustomerOrders(partnerId) {
    return new Promise(function (resolve, reject) {
        var ordersRef = collection(db, "orders");
        var ordersQuery;
        if (partnerId) {
            ordersQuery = query(ordersRef, where("tiffinId", "==", partnerId), where("customerId", "==", auth.currentUser.uid), where("status", "in", [OrderStatus.Completed, OrderStatus.Cancelled]), orderBy("date", "desc"), orderBy("time", "desc"), limit(ORDER_LIMIT));
        }
        else {
            ordersQuery = query(ordersRef, where("customerId", "==", auth.currentUser.uid), where("status", "in", [OrderStatus.Completed, OrderStatus.Cancelled]), orderBy("date", "desc"), orderBy("time", "desc"), limit(ORDER_LIMIT));
        }
        getDocs(ordersQuery).then(function (querySnapshot) {
            var records = [];
            querySnapshot.forEach(function (doc) {
                records.push(__assign({ id: doc.id, key: doc.id }, doc.data()));
            });
            resolve(records.filter(function (order) { return order.status !== OrderStatus.Unpaid; }));
        }, function (err) { return console.error(err); });
    });
}
export function fetchCustomerNextOrders(afterId, partnerId) {
    var _this = this;
    return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
        var ordersRef, afterOrder, ordersQuery;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ordersRef = collection(db, "orders");
                    return [4 /*yield*/, getDoc(doc(ordersRef, afterId))];
                case 1:
                    afterOrder = _a.sent();
                    if (partnerId) {
                        ordersQuery = query(ordersRef, where("tiffinId", "==", partnerId), where("customerId", "==", auth.currentUser.uid), where("status", "in", [OrderStatus.Completed, OrderStatus.Cancelled]), orderBy("date", "desc"), orderBy("time", "desc"), startAfter(afterOrder), limit(ORDER_LIMIT));
                    }
                    else {
                        ordersQuery = query(ordersRef, where("customerId", "==", auth.currentUser.uid), where("status", "in", [OrderStatus.Completed, OrderStatus.Cancelled]), orderBy("date", "desc"), orderBy("time", "desc"), startAfter(afterOrder), limit(ORDER_LIMIT));
                    }
                    getDocs(ordersQuery).then(function (querySnapshot) {
                        var records = [];
                        querySnapshot.forEach(function (doc) {
                            records.push(__assign({ id: doc.id, key: doc.id }, doc.data()));
                        });
                        resolve(records);
                    }, function (err) { return console.error(err); });
                    return [2 /*return*/];
            }
        });
    }); });
}
export function cancelOrder(id) {
    return new Promise(function (resolve, reject) {
        cloudFunction("userCancelOrder", { id: id }).then(function (result) {
            var _a;
            if (((_a = result.data) === null || _a === void 0 ? void 0 : _a.status) === "success") {
                resolve(null);
            }
        }, function (err) {
            reject(err.message);
        });
    });
}
